import React from "react";

export const ProfileIocn = () => {
  return (
    <>
      <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 6C0 2.68629 2.68629 0 6 0H30C33.3137 0 36 2.68629 36 6V30C36 33.3137 33.3137 36 30 36H6C2.68629 36 0 33.3137 0 30V6Z" fill="white"/>
        <g clipPath="url(#clip0_160_3486)">
        <path d="M18.0004 7.99707C18.9893 7.99707 19.956 8.29032 20.7782 8.83972C21.6005 9.38913 22.2413 10.17 22.6198 11.0837C22.9982 11.9973 23.0972 13.0026 22.9043 13.9725C22.7114 14.9424 22.2352 15.8333 21.5359 16.5326C20.8366 17.2319 19.9457 17.7081 18.9758 17.901C18.0059 18.0939 17.0006 17.9949 16.0869 17.6165C15.1733 17.238 14.3924 16.5972 13.843 15.7749C13.2936 14.9527 13.0004 13.986 13.0004 12.9971L13.0054 12.7801C13.0613 11.4928 13.612 10.2768 14.5426 9.38573C15.4732 8.49461 16.7119 7.99714 18.0004 7.99707Z" fill="#999999"/>
        <path d="M20.0004 19.9971C21.3264 19.9971 22.5982 20.5239 23.5359 21.4615C24.4736 22.3992 25.0004 23.671 25.0004 24.9971V25.9971C25.0004 26.5275 24.7897 27.0362 24.4146 27.4113C24.0395 27.7864 23.5308 27.9971 23.0004 27.9971H13.0004C12.4699 27.9971 11.9612 27.7864 11.5862 27.4113C11.2111 27.0362 11.0004 26.5275 11.0004 25.9971V24.9971C11.0004 23.671 11.5272 22.3992 12.4648 21.4615C13.4025 20.5239 14.6743 19.9971 16.0004 19.9971H20.0004Z" fill="#999999"/>
        </g>
        <defs>
        <clipPath id="clip0_160_3486">
        <rect width="24" height="24" fill="white" transform="translate(6.00037 5.99707)"/>
        </clipPath>
        </defs>
      </svg>
    </>
  );
};
